<div class="modal-container">

    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5" color="currentColor">
                        <path
                            d="M12.5 2h.273c3.26 0 4.892 0 6.024.798c.324.228.612.5.855.805c.848 1.066.848 2.6.848 5.67v2.545c0 2.963 0 4.445-.469 5.628c-.754 1.903-2.348 3.403-4.37 4.113c-1.257.441-2.83.441-5.98.441c-1.798 0-2.698 0-3.416-.252c-1.155-.406-2.066-1.263-2.497-2.35c-.268-.676-.268-1.523-.268-3.216V12" />
                        <path
                            d="M20.5 12a3.333 3.333 0 0 1-3.333 3.333c-.666 0-1.451-.116-2.098.057a1.67 1.67 0 0 0-1.179 1.179c-.173.647-.057 1.432-.057 2.098A3.333 3.333 0 0 1 10.5 22m-6-17.5C4.992 3.994 6.3 2 7 2m2.5 2.5C9.008 3.994 7.7 2 7 2m0 0v8" />
                    </g>
                </svg>
            </div>
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>

    <section class="modal-body">

        <div class="button-container">
            <ng-container *ngIf="downloadState === 'initial'">
                <button class="secondaryBtn" (click)="downloadAddMemberTemplate()">
                    Download
                </button>
            </ng-container>

            <ng-container
                *ngIf="downloadState === 'downloading' || downloadState === 'done' || downloadState === 'error'">
                <div class="downloadingBtn">
                    <div class="download-content">
                        <div class="download-icon">
                            <span *ngIf="downloadState === 'downloading'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-width="1">
                                        <path stroke-dasharray="2 4" stroke-dashoffset="6"
                                            d="M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9">
                                            <animate attributeName="stroke-dashoffset" dur="0.6s"
                                                repeatCount="indefinite" values="6;0" />
                                        </path>
                                        <path stroke-dasharray="32" stroke-dashoffset="32"
                                            d="M12 21c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9">
                                            <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s"
                                                dur="0.4s" values="32;0" />
                                        </path>
                                        <path stroke-dasharray="10" stroke-dashoffset="10" d="M12 8v7.5">
                                            <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s"
                                                dur="0.2s" values="10;0" />
                                        </path>
                                        <path stroke-dasharray="6" stroke-dashoffset="6"
                                            d="M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5">
                                            <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s"
                                                dur="0.2s" values="6;0" />
                                        </path>
                                    </g>
                                </svg>
                            </span>
                            <span *ngIf="downloadState === 'done'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 15 15">
                                    <path fill="none" stroke="#00E676"
                                        d="M4 7.5L7 10l4-5m-3.5 9.5a7 7 0 1 1 0-14a7 7 0 0 1 0 14Z" stroke-width="1" />
                                </svg>
                            </span>
                        </div>
                        <div class="download-text">
                            <ng-container *ngIf="downloadState === 'downloading'">{{ downloadProgress }}%
                                Done</ng-container>
                            <ng-container *ngIf="downloadState === 'done'">Done!</ng-container>
                            <ng-container *ngIf="downloadState === 'error'">Error</ng-container>
                        </div>
                    </div>
                    <div class="progress-bar-container">
                        <div class="progress-bar" [style.width]="downloadProgress + '%'"></div>
                    </div>
                </div>
            </ng-container>
        </div>

        <ng-container>
            <app-file-upload (uploadedFile)="confirmation($event)"></app-file-upload>
            <ng-container *ngIf="isFileUploading; else fileUploadBlock">
                <div class="progress-wrapper">
                    <mat-progress-bar mode="determinate" [value]="uploadProgress" class="upload-progress-bar">
                    </mat-progress-bar>
                    <span class="progress-percent">{{ uploadProgress }}%</span>
                </div>
            </ng-container>

            <ng-template #fileUploadBlock>
                <div *ngIf="selectedFile" class="file-upload-bar">
                    <div class="file-info">
                        <span class="file-name">{{ selectedFile.name }}</span>
                    </div>

                    <button class="primaryBtn" (click)="uploadFile(selectedFile)" [disabled]="isFileUploading">
                        <span class="btnContent">Upload</span>
                    </button>
                </div>
            </ng-template>
        </ng-container>

    </section>

</div>